
import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import DataLinkButton from "@/components/ui/data-link-button";
import { ForecastCardProps } from "./types";
import { createDataSource } from "./utils";

export function PreRevenueProjectCard({ model, onViewData }: ForecastCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between">
        <div>
          <CardTitle>{model.name}</CardTitle>
          <CardDescription>
            {model.startYear} - {model.endYear} | Pre-Revenue
          </CardDescription>
        </div>
        <DataLinkButton 
          dataSource={createDataSource(model)}
          onViewData={onViewData}
        />
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Burn Rate:</span>
            <span className="font-medium">${model.roiMetrics?.burnRate.toLocaleString()}/month</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Total Investment:</span>
            <span className="font-medium">
              ${model.capitalCosts.reduce((sum, cost) => sum + cost, 0).toLocaleString()}
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Key Milestone:</span>
            <span className="font-medium">
              {model.milestoneProjections?.[0].name} ({model.milestoneProjections?.[0].date})
            </span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Value After Milestone:</span>
            <span className="font-medium">
              ${model.milestoneProjections?.[0].valueAfter.toLocaleString()}
            </span>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="secondary" className="w-full">View Details</Button>
      </CardFooter>
    </Card>
  );
}
